import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithGoogle } from '../firebase';
import SpatialCanvas from '../components/SpatialCanvas';

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true); setError('');
    try {
      await signInWithGoogle();
      navigate('/');
    } catch (e) {
      setError(e.message);
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      padding: 32,
    }}>
      <div style={{ width: '100%', maxWidth: 880, display: 'flex', gap: 64, alignItems: 'center' }}>

        {/* Left — canvas */}
        <div style={{
          flex: 1, display: 'flex', flexDirection: 'column', gap: 0,
        }}>
          <div style={{
            background: 'var(--surface)',
            border: '1px solid var(--border)',
            borderRadius: 10, overflow: 'hidden',
          }}>
            <SpatialCanvas width={420} height={280} />
          </div>
          <div style={{
            marginTop: 16, fontSize: 11,
            fontFamily: 'IBM Plex Mono, monospace',
            color: 'var(--muted)', lineHeight: 1.8,
          }}>
            <span style={{ color: 'var(--rust)' }}>civil3d</span> ·
            AI 3D Reconstruction Platform ·
            by <a href="https://blackvanilla.ai" target="_blank" rel="noreferrer" style={{ color: '#C8F04A', textDecoration: 'none', opacity: 0.7 }}>Black Vanilla Technologies</a>
          </div>
        </div>

        {/* Right — login */}
        <div style={{ width: 320 }}>
          {/* Logo */}
          <div style={{ marginBottom: 36 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
              <div style={{ width: 28, height: 28, position: 'relative',
                display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{
                  width: 20, height: 20,
                  border: '1.5px solid var(--rust)', borderRadius: 4,
                  transform: 'rotate(15deg)', position: 'absolute',
                }} />
                <div style={{
                  width: 10, height: 10,
                  background: 'var(--rust)', borderRadius: 2,
                  transform: 'rotate(15deg)',
                }} />
              </div>
              <span style={{
                fontFamily: 'IBM Plex Mono, monospace',
                fontWeight: 500, fontSize: 16, color: 'var(--white)',
              }}>civil3d</span>
            </div>
            <a href="https://blackvanilla.ai" target="_blank" rel="noreferrer" style={{
              fontFamily: 'IBM Plex Mono, monospace',
              fontSize: 10, color: '#C8F04A',
              textDecoration: 'none', letterSpacing: '0.1em',
              opacity: 1, display: 'inline-block',
              transition: 'opacity 0.2s',
            }}
            onMouseEnter={e => e.target.style.opacity = 0.75}
            onMouseLeave={e => e.target.style.opacity = 1}>
              A BLACK VANILLA TECHNOLOGIES PLATFORM →
            </a>
          </div>

          <h1 style={{ fontSize: 26, fontWeight: 500, marginBottom: 10 }}>
            Sign in to continue
          </h1>
          <p style={{
            color: 'var(--muted)', fontSize: 14,
            lineHeight: 1.6, marginBottom: 32,
          }}>
            Upload walkthrough videos. Get precise 3D models,
            measurements, and an AI that understands your space.
          </p>

          {error && (
            <div style={{
              background: 'rgba(232,84,84,0.08)',
              border: '1px solid rgba(232,84,84,0.25)',
              borderRadius: 6, padding: '10px 14px',
              color: 'var(--red)', fontSize: 13, marginBottom: 20,
            }}>{error}</div>
          )}

          <button
            onClick={handleLogin}
            disabled={loading}
            style={{
              width: '100%', display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              gap: 12, padding: '12px 20px',
              background: 'var(--surface)',
              border: '1px solid var(--border-hi)',
              borderRadius: 8, cursor: loading ? 'not-allowed' : 'pointer',
              color: 'var(--white)', fontSize: 14,
              fontFamily: 'DM Sans, sans-serif',
              transition: 'all 0.15s',
              opacity: loading ? 0.6 : 1,
            }}
            onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--rust)'}
            onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border-hi)'}
          >
            {/* Google icon */}
            <svg width="18" height="18" viewBox="0 0 48 48">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
            </svg>
            {loading ? 'Signing in...' : 'Continue with Google'}
          </button>

          {/* Terms */}
          <p style={{
            marginTop: 20, fontSize: 11,
            color: 'var(--muted)', lineHeight: 1.7,
            fontFamily: 'IBM Plex Mono, monospace',
          }}>
            By signing in you agree to{' '}
            <a href="https://blackvanilla.ai" target="_blank" rel="noreferrer"
              style={{color:'var(--rust)',textDecoration:'none'}}>
              Black Vanilla Technologies
            </a>
            {' '}terms of service and privacy policy.
            Your data is stored securely on Google Cloud.
          </p>

          {/* BV Footer — single, visible */}
          <div style={{
            marginTop: 28, paddingTop: 20,
            borderTop: '1px solid var(--border)',
          }}>
            <a href="https://blackvanilla.ai" target="_blank" rel="noreferrer"
              style={{textDecoration:'none',display:'flex',alignItems:'center',gap:8,marginBottom:10}}>
              {/* BV point-cloud mini mark */}
              <svg viewBox="4 3 74 62" width="22" height="18" style={{flexShrink:0}}>
                <circle cx="64" cy="24" r="2.5" fill="#C8F04A" opacity="1"/>
                <circle cx="58" cy="20.5" r="2.35" fill="#C8F04A" opacity="0.9"/>
                <circle cx="52" cy="17" r="2.2" fill="#C8F04A" opacity="0.8"/>
                <circle cx="64" cy="31" r="2.35" fill="#C8F04A" opacity="0.9"/>
                <circle cx="58" cy="27.5" r="2.2" fill="#C8F04A" opacity="0.8"/>
                <circle cx="52" cy="24" r="2.05" fill="#C8F04A" opacity="0.75"/>
                <circle cx="46" cy="20.5" r="1.9" fill="#C8F04A" opacity="0.7"/>
                <circle cx="16" cy="24" r="2.1" fill="#A8D040" opacity="0.65"/>
                <circle cx="22" cy="20.5" r="1.99" fill="#A8D040" opacity="0.6"/>
                <circle cx="28" cy="17" r="1.88" fill="#A8D040" opacity="0.55"/>
                <circle cx="40" cy="17" r="2.0" fill="#C8F04A" opacity="0.85"/>
                <circle cx="34" cy="20.5" r="1.9" fill="#C8F04A" opacity="0.8"/>
              </svg>
              <div>
                <div style={{fontFamily:'IBM Plex Mono,monospace',fontSize:11,fontWeight:500,color:'#C8F04A',letterSpacing:'0.06em'}}>
                  Black Vanilla Technologies
                </div>
                <div style={{fontFamily:'IBM Plex Mono,monospace',fontSize:9,color:'rgba(255,255,255,0.4)',letterSpacing:'0.08em',marginTop:2}}>
                  blackvanilla.ai
                </div>
              </div>
            </a>
            <div style={{display:'flex',gap:16,flexWrap:'wrap'}}>
              <a href="https://blackvanilla.ai#terms" target="_blank" rel="noreferrer"
                style={{fontFamily:'IBM Plex Mono,monospace',fontSize:9,color:'rgba(255,255,255,0.35)',textDecoration:'none',letterSpacing:'0.08em',textTransform:'uppercase',transition:'color 0.2s'}}
                onMouseEnter={e=>e.target.style.color='rgba(255,255,255,0.7)'}
                onMouseLeave={e=>e.target.style.color='rgba(255,255,255,0.35)'}>
                Terms of Service
              </a>
              <a href="https://blackvanilla.ai#privacy" target="_blank" rel="noreferrer"
                style={{fontFamily:'IBM Plex Mono,monospace',fontSize:9,color:'rgba(255,255,255,0.35)',textDecoration:'none',letterSpacing:'0.08em',textTransform:'uppercase',transition:'color 0.2s'}}
                onMouseEnter={e=>e.target.style.color='rgba(255,255,255,0.7)'}
                onMouseLeave={e=>e.target.style.color='rgba(255,255,255,0.35)'}>
                Privacy Policy
              </a>
              <span style={{fontFamily:'IBM Plex Mono,monospace',fontSize:9,color:'rgba(255,255,255,0.2)',letterSpacing:'0.06em'}}>
                © 2026
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
